import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Shield, ShieldCheck, ShieldQuestion } from "lucide-react";

const tiers = [
  {
    Icon: ShieldCheck,
    label: "Verified",
    color: "text-[hsl(40_55%_51%)]",
    description:
      "We manually confirm the provider is active on at least one licensed BNPL partner's catalogue. Verification is refreshed monthly.",
  },
  {
    Icon: Shield,
    label: "Official Partner",
    color: "text-[hsl(210_53%_23%)]",
    description:
      "Flexaura has a formal referral or commercial agreement with this provider. Transactions are tracked, and pricing is validated.",
  },
  {
    Icon: ShieldQuestion,
    label: "Community Listed",
    color: "text-muted-foreground",
    description:
      "Listed based on publicly available provider catalogues or user submissions. Availability and pricing should be confirmed at checkout.",
  },
];

interface VerificationModalProps {
  trigger: React.ReactNode;
}

const VerificationModal = ({ trigger }: VerificationModalProps) => (
  <Dialog>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="font-heading">How we verify listings</DialogTitle>
      </DialogHeader>
      <div className="space-y-5 mt-2">
        {tiers.map((t) => (
          <div key={t.label} className="flex gap-3">
            <t.Icon className={`w-5 h-5 mt-0.5 flex-shrink-0 ${t.color}`} />
            <div>
              <p className="font-semibold text-sm text-foreground">{t.label}</p>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {t.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default VerificationModal;
